import { useCallback, useEffect, useRef, useState } from 'react';
import { getRuntimeConfig } from 'helpers/runtimeConfig';

const useHealthCheck = () => {
  const isInvoked = useRef(false);
  const [isMaintenance, setIsMaintenance] = useState(false);
  const [healthCheckFirstInvoke, setHealthCheckFirstInvoke] = useState(true);
  const [maintenanceTimeEnd, setMaintenanceTimeEnd] = useState(null);

  const invokeHealthCheckApi = useCallback(async () => {
    isInvoked.current = true;
    try {
      fetch(`${getRuntimeConfig().env.REACT_APP_API_BASEURL}/api/v2/3/healthCheck`, {
        method: 'GET',
      })
        .then((response) => {
          setIsMaintenance(response.status === 427);

          return response.json();
        })
        .then((response) => {
          setMaintenanceTimeEnd(response?.endDate || null);

          return response;
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    if (!isInvoked.current) {
      invokeHealthCheckApi().finally(() => {
        setHealthCheckFirstInvoke(false);
      });
    }
  }, [invokeHealthCheckApi]);

  useEffect(() => {
    const timer = setInterval(() => {
      invokeHealthCheckApi().then();
    }, 10000);

    return () => {
      clearInterval(timer);
    };
  }, [invokeHealthCheckApi]);

  return { isMaintenance, healthCheckFirstInvoke, maintenanceTimeEnd };
};

export default useHealthCheck;
